import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@massds/mayflower-react';

import logo from '../../images/stateseal.png';
import './index.scss';

const SiteLogo = (siteLogo) => {
  const baseClass = 'ma__budget-site-logo';
  const className = siteLogo.theme ? `${baseClass} ${baseClass}--${siteLogo.theme}` : baseClass;
  return(
    <div className={className}>
      <a href={siteLogo.url.domain ? siteLogo.url.domain : '/'} title={siteLogo.title}>
        <Image {...siteLogo.image} />
        <div className={`${baseClass}--block`}>
          <span className={siteLogo.theme ? `${baseClass}--sitename ${baseClass}--sitename--${siteLogo.theme}` : `${baseClass}--sitename`}>{siteLogo.siteName}</span>
          {siteLogo.subTitle && <span className={siteLogo.theme ? `${baseClass}--subtitle ${baseClass}--subtitle--${siteLogo.theme}` : `${baseClass}--subtitle`}>{siteLogo.subTitle}</span>}
        </div>
      </a>
    </div>
  );
};

SiteLogo.propTypes = {
  /** The URL for the site */
  url: PropTypes.shape({
    /** The URL for the site root */
    domain: PropTypes.string
  }),
  // The site logo image: state seal.
  image: PropTypes.shape(PropTypes.Image),
  // The site name is rendered next to the site logo
  siteName: PropTypes.string,
  // The title is rendered as the link title of the SiteLogo, displayed when mouse over the SiteLogo
  title: PropTypes.string,
  // The site subTitle is rendered below the site name with a colored background
  subTitle: PropTypes.string,
  // The theme controls the color used in the SiteLogo
  theme: PropTypes.oneOf(['govbudget', 'capital', 'summary', ''])
};

SiteLogo.defaultProps = {
  url: {
    domain: '/'
  },
  image: {
    src: logo,
    alt: '',
    width: 45,
    height: 45
  },
  siteName: 'Mass.gov',
  title: 'Mass.gov homepage',
  theme: ''
};

export default SiteLogo;
